<template>
  <v-app>
    <vue-snotify></vue-snotify>
    <div class="hyp-container" dark><router-view /></div>
  </v-app>
</template>

<style>
@import "https://api.tiles.mapbox.com/mapbox-gl-js/v1.5.0/mapbox-gl.css";
@import "https://api.mapbox.com/mapbox-gl-js/plugins/mapbox-gl-draw/v1.0.9/mapbox-gl-draw.css";

@font-face {
  font-family: "TruenoLt";
  src: url("./assets/fonts/TruenoLt.otf");
}
@font-face {
  font-family: "TruenoRg";
  src: url("./assets/fonts/TruenoRg.otf");
}
.application {
  font-family: TruenoLt;
}
.hyp-container {
  height: 100%;
  background-color: black;
  -webkit-font-smoothing: subpixel-antialiased;
}
</style>

<script>
import {
  DEPLOY_ENV,
  DATADOG_APP_ID,
  DATADOG_RUM_CLIENT_TOKEN,
} from "@/common/config";
import { Datacenter, datadogRum } from "@datadog/browser-rum";

export default {
  name: "App",
  async mounted() {
    if (DEPLOY_ENV && DATADOG_APP_ID && DATADOG_RUM_CLIENT_TOKEN) {
      let res = datadogRum.init({
        applicationId: DATADOG_APP_ID,
        clientToken: DATADOG_RUM_CLIENT_TOKEN,
        datacenter: Datacenter.US,
        sampleRate: 100,
        env: DEPLOY_ENV,
        trackInteractions: true,
      });
    }
  },
};
</script>
